import React from "react";

/* eslint-disable max-len */
export default function AdminAccessableIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} viewBox="0 0 30 30">
            <defs>
                <clipPath id="a">
                    <path data-name="\u9577\u65B9\u5F62 1699" fill="#9c9c9c" d="M0 0H17.03V23H0z" />
                </clipPath>
            </defs>
            <g data-name="\u30B0\u30EB\u30FC\u30D7 554">
                <g data-name="\u30B0\u30EB\u30FC\u30D7 509">
                    <g
                        data-name="\u30B0\u30EB\u30FC\u30D7 508"
                        transform="translate(-40 -455) translate(52.5 458.5) translate(-6)"
                        clipPath="url(#a)"
                    >
                        <path
                            data-name="\u30D1\u30B9 8126"
                            d="M15.895 8.24h-1.422V5.964a5.964 5.964 0 10-11.928 0V8.24h-1.41A1.135 1.135 0 000 9.376v12.489A1.135 1.135 0 001.135 23h14.76a1.135 1.135 0 001.135-1.135V9.376a1.135 1.135 0 00-1.135-1.136M4.255 5.964a4.254 4.254 0 118.509 0V8.24H4.255zm5.4 10.791a1.135 1.135 0 01-2.271 0v-2.27a1.135 1.135 0 012.271 0z"
                            fill="#9c9c9c"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
}
